import { envelopeRegistry } from '../Service';
const isRpcResponse = (v) => {
    return v.content !== undefined && v.headers !== undefined;
};
envelopeRegistry.set('JSON-RPC-2.0', {
    serialize(smd, method, data, options) {
        const d = {
            id: this._requestId++,
            method: method.name,
            params: data,
            jsonrpc: '2.0'
        };
        return {
            data: JSON.stringify(d),
            handleAs: 'json',
            contentType: 'application/json',
            transport: 'POST'
        };
    },
    deserialize(o) {
        if (isRpcResponse(o)) {
            return o;
        }
        const obj = (o.responseText && JSON.parse(o.responseText)) || o;
        return obj.result;
    },
    namedParams: true
});
